/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: { 
      boxSizing: 'content-box'
    },
    li: { 
    },
    icon: {
      paddingRight: theme.spacing(1)
    }
  })
);
